import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-black px-5">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
        <h1 className="font-display text-5xl leading-none">
          YAZA <span className="text-yaza-accent">EXOTICS</span>
        </h1>
        <p className="mt-2 text-xs uppercase tracking-[0.3em] text-neutral-500">Admin Access</p>

        <div className="mt-10 flex flex-col gap-5">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-email"
            className="w-full border-b border-white/30 bg-transparent py-3 outline-none focus:border-yaza-accent"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password"
            className="w-full border-b border-white/30 bg-transparent py-3 outline-none focus:border-yaza-accent"
          />
        </div>

        {error && <p className="mt-4 text-sm text-yaza-accent" data-testid="admin-login-error">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="mt-8 w-full rounded-none bg-yaza-accent py-4 text-sm font-bold uppercase tracking-[0.2em] text-black transition-colors hover:bg-yaza-accentHover disabled:opacity-50"
        >
          {loading ? "…" : "Enter"}
        </button>
      </form>
    </div>
  );
}
